/**
 * @desc Export table layout configuration.
 * @example
 * import { entityConfig } from 'config/entity-info/to-do-detail-summary';
 */
export const entityConfig = {
    valueColors: {
        resolution: {
            resolved: '#59ad00',
            unresolved: '#e7aa00',
        },
        status: {
            closed: '#59ad00',
            open: '#e7aa00',
        }
    }
};
